import { render } from "./PendingBookingRequests.vue?vue&type=template&id=009c1196&scoped=true"
import script from "./PendingBookingRequests.vue?vue&type=script&lang=js"
export * from "./PendingBookingRequests.vue?vue&type=script&lang=js"

import "./PendingBookingRequests.vue?vue&type=style&index=0&id=009c1196&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009c1196"]])

export default __exports__